import { IonLabel } from "@ionic/react";
import CheckmarkBadgeSuccess from "../../../../Common/assets/icons/survey/checkmark-badge-success.svg?react";
import { useWebUserStore } from "../../../CommonStores/user/users";
import s from "./SurveySuccessSection.module.scss";

export const SurveySuccessSection = () => {
  const { user } = useWebUserStore();

  return (
    <div className={s.successSectionWrapper}>
      <div className={s.successSection}>
        <div className={s.successContent}>
          <CheckmarkBadgeSuccess className={s.successIcon} />

          <div className={s.successContentText}>
            <IonLabel className="win-header-1 winner-sans medium white ion-text-uppercase">
              {user?.firstName ? `Thanks, ${user.firstName}!` : "Thanks!"}
            </IonLabel>
            <IonLabel className="win-header-5 gilroy medium blue-grey200_2">
              Survey complete —go ahead and grab your in-app rewards!
            </IonLabel>
          </div>
        </div>
        <IonLabel className="win-header-5 gilroy medium blue-grey200_2">
          You can now close this page
        </IonLabel>
      </div>
    </div>
  );
};
